import { LineString } from 'geojson';
export const metropolitanBorder: LineString = {
    type: 'LineString',
    coordinates: [
        [3.1824177, 42.4244803],
        [3.1640748, 42.4538009],
        [3.1559058, 42.4763111],
        [3.1341497, 42.4818635],
        [3.1295927, 42.5034487],
        [3.1357335, 42.5087897],
        [3.1394726, 42.5159459],
        [3.1298002, 42.518712],
        [3.0971135, 42.5252357],
        [3.0874706, 42.5306927],
        [3.0729496, 42.5343857],
        [3.0548396, 42.542592],
        [3.0444805, 42.5893567],
        [3.0457941, 42.5974307],
        [3.0365685, 42.6388014],
        [3.0382195, 42.6747131],
        [3.0387301, 42.7169208],
        [3.0365871, 42.741185],
        [3.0369875, 42.7744144],
        [3.0414317, 42.8390559],
        [3.0607479, 42.9197719],
        [3.0388488, 42.9280029],
        [3.0376915, 42.9334],
        [3.0133283, 42.9407441],
        [2.9915668, 42.9624386],
        [3.0002932, 42.976759],
        [3.0260576, 42.9828843],
        [3.0183353, 42.9505929],
        [3.0207499, 42.9478834],
        [3.0390016, 42.9405787],
        [3.0402458, 42.9423669],
        [3.0417985, 42.9693061],
        [3.045489, 42.9710791],
        [3.0857485, 43.0570506],
        [3.0735448, 43.0607292],
        [3.0636425, 43.0527106],
        [3.0331399, 43.0627963],
        [3.0295923, 43.073601],
        [3.0349066, 43.1077072],
        [3.0471465, 43.1058299],
        [3.0469691, 43.0914553],
        [3.0775324, 43.0849596],
        [3.0797629, 43.0678742],
        [3.0895058, 43.0633142],
        [3.1506264, 43.1401356],
        [3.1817445, 43.1704447],
        [3.2413377, 43.2130911],
        [3.2723675, 43.2325955],
        [3.3033562, 43.2484948],
        [3.3120659, 43.254707],
        [3.3442776, 43.2687879],
        [3.3652906, 43.2748795],
        [3.4282547, 43.2877393],
        [3.5102694, 43.268004],
        [3.5215369, 43.2777658],
        [3.53926, 43.3018342],
        [3.5542684, 43.3133482],
        [3.5668624, 43.3266858],
        [3.638169, 43.3770762],
        [3.6605886, 43.3875882],
        [3.6914928, 43.3916978],
        [3.7278315, 43.4164024],
        [3.799961, 43.4406147],
        [3.8265094, 43.4654198],
        [3.9081452, 43.5172957],
        [3.975562, 43.5423639],
        [4.0340675, 43.5567443],
        [4.1044615, 43.5547156],
        [4.1454418, 43.5216737],
        [4.1250974, 43.5031353],
        [4.1320503, 43.4886364],
        [4.1733433, 43.4672648],
        [4.2335455, 43.4590315],
        [4.4046087, 43.4460001],
        [4.4789524, 43.4544394],
        [4.5466316, 43.4494762],
        [4.5879536, 43.4333383],
        [4.6029808, 43.4078512],
        [4.5688064, 43.3851887],
        [4.5704987, 43.3653756],
        [4.5959631, 43.3549562],
        [4.6204025, 43.3499448],
        [4.6100719, 43.3690432],
        [4.6278118, 43.3812526],
        [4.6210319, 43.3966807],
        [4.6201584, 43.4056905],
        [4.6580587, 43.3976882],
        [4.6606975, 43.3715584],
        [4.6660145, 43.350766],
        [4.7927789, 43.3479494],
        [4.8387604, 43.3289104],
        [4.8664183, 43.3417491],
        [4.8853966, 43.3529898],
        [4.8905183, 43.3573642],
        [4.8581546, 43.3779068],
        [4.8565983, 43.3986222],
        [4.8896241, 43.4203238],
        [4.9259255, 43.4320473],
        [4.9748483, 43.4227682],
        [4.9884277, 43.3963579],
        [4.9984493, 43.3997083],
        [5.0415555, 43.3986345],
        [5.05914, 43.4053857],
        [5.0560033, 43.4432322],
        [5.0510336, 43.468536],
        [5.0103805, 43.4704504],
        [4.9983595, 43.5040187],
        [5.0177965, 43.5233222],
        [5.0142042, 43.552187],
        [5.0242517, 43.5555365],
        [5.0475471, 43.5252769],
        [5.1081156, 43.5255384],
        [5.1176416, 43.5180983],
        [5.1135463, 43.5101098],
        [5.1351895, 43.4726804],
        [5.1599775, 43.4495521],
        [5.1662751, 43.4520855],
        [5.1581321, 43.462191],
        [5.2027692, 43.490691],
        [5.2256606, 43.4792895],
        [5.222888, 43.4487872],
        [5.177176, 43.4230214],
        [5.1744884, 43.4185957],
        [5.1241155, 43.3974301],
        [5.1183498, 43.4056721],
        [5.0984264, 43.4016877],
        [5.0725594, 43.4023483],
        [5.0473747, 43.3912953],
        [4.9977812, 43.385338],
        [5.0247951, 43.3567929],
        [5.0205989, 43.3461076],
        [5.0431746, 43.3284597],
        [5.0901316, 43.3317639],
        [5.1368339, 43.3296596],
        [5.1935964, 43.331765],
        [5.2280851, 43.331744],
        [5.2380605, 43.3341735],
        [5.287282, 43.3571135],
        [5.3084804, 43.3619272],
        [5.3398675, 43.3493658],
        [5.3664575, 43.3162465],
        [5.3487276, 43.2834715],
        [5.372548, 43.2684137],
        [5.3766545, 43.2530122],
        [5.3315559, 43.2138137],
        [5.3338231, 43.2101544],
        [5.4236134, 43.2112078],
        [5.5090319, 43.1997257],
        [5.5342729, 43.2115678],
        [5.5476743, 43.2093704],
        [5.5565355, 43.1920183],
        [5.6064301, 43.1617338],
        [5.6224793, 43.1846242],
        [5.6751204, 43.1812024],
        [5.691066, 43.1807046],
        [5.6965683, 43.1697409],
        [5.6862876, 43.1619683],
        [5.6928598, 43.1482743],
        [5.7303321, 43.1381016],
        [5.77099, 43.1404052],
        [5.7828715, 43.1337301],
        [5.7746072, 43.1187056],
        [5.8087487, 43.1149076],
        [5.8125637, 43.0967981],
        [5.7987534, 43.0711662],
        [5.8294921, 43.0521817],
        [5.8477923, 43.0506861],
        [5.8611443, 43.048448],
        [5.8886648, 43.0772157],
        [5.9044127, 43.0739951],
        [5.911313, 43.0665697],
        [5.950761, 43.0697437],
        [5.9468787, 43.0860635],
        [5.9187723, 43.0879063],
        [5.9073635, 43.0819899],
        [5.9025212, 43.0830508],
        [5.9002937, 43.0867217],
        [5.9110374, 43.1016525],
        [5.8855375, 43.1060987],
        [5.8887645, 43.118582],
        [5.9354845, 43.1197231],
        [5.929688, 43.1055268],
        [5.9839182, 43.1090922],
        [5.9997849, 43.1076517],
        [6.0237054, 43.0978366],
        [6.0191714, 43.0845029],
        [6.0409191, 43.0792556],
        [6.1088347, 43.0858813],
        [6.1268426, 43.079849],
        [6.1296877, 43.0671546],
        [6.1332215, 43.0463427],
        [6.0936628, 43.0414426],
        [6.0934869, 43.0387495],
        [6.0990178, 43.0295627],
        [6.1386286, 43.0353578],
        [6.1456113, 43.0297126],
        [6.1566177, 43.0293208],
        [6.1704897, 43.0351221],
        [6.1548874, 43.0401774],
        [6.1576247, 43.0814528],
        [6.1979778, 43.1159869],
        [6.2371721, 43.114568],
        [6.2733027, 43.1222428],
        [6.3628416, 43.0856319],
        [6.3735773, 43.0987226],
        [6.3645685, 43.1278498],
        [6.3714488, 43.1383855],
        [6.4176694, 43.1492333],
        [6.4443703, 43.1446149],
        [6.4550086, 43.1559033],
        [6.4929315, 43.15354],
        [6.5331257, 43.1654725],
        [6.5352676, 43.177985],
        [6.5544459, 43.1880302],
        [6.6009704, 43.1852924],
        [6.604181, 43.1788654],
        [6.6176211, 43.1612325],
        [6.6366066, 43.1685716],
        [6.6419123, 43.1737581],
        [6.6468826, 43.1744585],
        [6.6453064, 43.18622],
        [6.6570813, 43.1956446],
        [6.6779254, 43.1948029],
        [6.6833713, 43.2017832],
        [6.6657887, 43.2132918],
        [6.6667274, 43.2420505],
        [6.6783148, 43.2487817],
        [6.6897677, 43.2537181],
        [6.6982217, 43.2677742],
        [6.6832139, 43.2809814],
        [6.6720267, 43.2796335],
        [6.6714173, 43.271559],
        [6.6649396, 43.2673202],
        [6.6554563, 43.2722016],
        [6.6434471, 43.2762826],
        [6.6292697, 43.2678506],
        [6.5908777, 43.2648778],
        [6.5854013, 43.2740936],
        [6.5871606, 43.2812228],
        [6.6076115, 43.2912114],
        [6.6217915, 43.2996464],
        [6.6636822, 43.3159676],
        [6.6780064, 43.3423889],
        [6.7156375, 43.3507655],
        [6.7163281, 43.3759373],
        [6.7443103, 43.418898],
        [6.7657195, 43.4243215],
        [6.7871103, 43.4135379],
        [6.8589124, 43.415948],
        [6.8601169, 43.4311999],
        [6.8713394, 43.4325294],
        [6.8733734, 43.4270422],
        [6.8906067, 43.4263148],
        [6.9209289, 43.4502349],
        [6.9296061, 43.481374],
        [6.9496097, 43.4841207],
        [6.9573646, 43.5035948],
        [6.9409756, 43.5150997],
        [6.9578724, 43.5404857],
        [7.0327513, 43.5480583],
        [7.0337641, 43.5453129],
        [7.0406446, 43.5387111],
        [7.0564073, 43.5497276],
        [7.0866409, 43.5709109],
        [7.1125506, 43.5697684],
        [7.1218487, 43.547747],
        [7.1253227, 43.5448907],
        [7.1367225, 43.5479863],
        [7.1458098, 43.5529837],
        [7.1291156, 43.5753383],
        [7.1328849, 43.6201946],
        [7.1461166, 43.6448198],
        [7.1530512, 43.6535166],
        [7.1793764, 43.656844],
        [7.202853, 43.6557902],
        [7.2288727, 43.6699253],
        [7.2403814, 43.6883159],
        [7.2893707, 43.6950909],
        [7.2972436, 43.6857241],
        [7.3089157, 43.6914929],
        [7.3069914, 43.697886],
        [7.3175874, 43.7055045],
        [7.3246928, 43.7015739],
        [7.3275161, 43.6771255],
        [7.3517872, 43.6850101],
        [7.3371356, 43.7019014],
        [7.3493683, 43.7139446],
        [7.3494478, 43.7148423],
        [7.3650008, 43.7222265],
        [7.3720253, 43.7173972],
        [7.3884205, 43.720235],
        [7.4093649, 43.7183551],
        [7.4175861, 43.7269771],
        [7.4418597, 43.7483537],
        [7.4548773, 43.7549471],
        [7.4626256, 43.7581843],
        [7.4840075, 43.74726],
        [7.4893435, 43.7650232],
        [7.5320684, 43.783702],
        [7.5314847, 43.7909374],
        [7.5211599, 43.8004409],
        [7.5186715, 43.8140735],
        [7.4994704, 43.8492238],
        [7.5058827, 43.8786476],
        [7.5674704, 43.8982213],
        [7.5739224, 43.9411585],
        [7.5896497, 43.9494104],
        [7.6515115, 43.9707297],
        [7.6751582, 43.9966045],
        [7.6676427, 44.0095887],
        [7.666676, 44.0258568],
        [7.7067423, 44.0401066],
        [7.7230169, 44.0798574],
        [7.6873278, 44.1122582],
        [7.6753016, 44.1173545],
        [7.6790037, 44.1433076],
        [7.6868735, 44.1735629],
        [7.6384325, 44.1777323],
        [7.6343414, 44.160808],
        [7.6217834, 44.1469994],
        [7.5685427, 44.1531721],
        [7.4374334, 44.1287491],
        [7.4324035, 44.1145689],
        [7.3902204, 44.1183365],
        [7.3613357, 44.1169676],
        [7.3463634, 44.1455867],
        [7.2652837, 44.1483827],
        [7.2424615, 44.1737371],
        [7.2244619, 44.1682378],
        [7.211754, 44.1805175],
        [7.2009176, 44.1855068],
        [7.1970872, 44.1991909],
        [7.1459413, 44.2014566],
        [7.0784128, 44.2323369],
        [7.0425627, 44.2230785],
        [7.0358196, 44.2323768],
        [7.0231888, 44.2311186],
        [7.0066778, 44.2435357],
        [7.0022276, 44.2806588],
        [6.9632025, 44.2940281],
        [6.9660002, 44.3128247],
        [6.9197966, 44.3462981],
        [6.8946153, 44.3608617],
        [6.9030998, 44.4190605],
        [6.9490743, 44.4279428],
        [6.9474506, 44.4388216],
        [6.9192904, 44.4481097],
        [6.9133055, 44.4672781],
        [6.8786158, 44.4894388],
        [6.8636144, 44.5062734],
        [6.8604746, 44.529825],
        [6.9370893, 44.5734855],
        [6.9404816, 44.5994701],
        [6.9724926, 44.6206474],
        [6.9551896, 44.6556118],
        [6.9671811, 44.6785316],
        [6.9985002, 44.6907253],
        [7.0082692, 44.6867049],
        [7.021079, 44.6888654],
        [7.0364813, 44.6918116],
        [7.0795403, 44.6782512],
        [7.0873187, 44.6806182],
        [7.0736187, 44.7127448],
        [7.0366766, 44.72424],
        [7.027997, 44.7714631],
        [7.0054741, 44.789539],
        [7.0271727, 44.8219571],
        [7.0085644, 44.8416687],
        [6.9874095, 44.8461657],
        [6.9382576, 44.8644454],
        [6.917846, 44.8472744],
        [6.8888891, 44.8493726],
        [6.8430547, 44.8620659],
        [6.7779446, 44.9034435],
        [6.7579395, 44.9069492],
        [6.7533437, 44.9449705],
        [6.771425, 44.9649682],
        [6.7539455, 44.9845858],
        [6.7417869, 44.9913784],
        [6.7408051, 44.9950206],
        [6.7550835, 44.9989556],
        [6.7489119, 45.0172211],
        [6.6756815, 45.0228188],
        [6.6317433, 45.1119163],
        [6.6759206, 45.1237109],
        [6.6821884, 45.1387815],
        [6.7132097, 45.1447686],
        [6.7445801, 45.1390219],
        [6.7742885, 45.1603628],
        [6.8017814, 45.1538536],
        [6.8610914, 45.131628],
        [6.8999623, 45.1399479],
        [6.8896475, 45.1538877],
        [6.897098, 45.1670977],
        [6.9395073, 45.1716551],
        [6.9548158, 45.1719204],
        [6.9684125, 45.1974871],
        [6.9639322, 45.2048824],
        [7.0031706, 45.2167576],
        [7.0272318, 45.2148425],
        [7.0510913, 45.225549],
        [7.0769307, 45.2145349],
        [7.1103521, 45.2473522],
        [7.1254507, 45.2448988],
        [7.1391715, 45.2560231],
        [7.1416608, 45.2847573],
        [7.1185467, 45.3127917],
        [7.1200197, 45.3298519],
        [7.1444396, 45.3315043],
        [7.1422556, 45.3505252],
        [7.1685863, 45.3593003],
        [7.1734097, 45.3852287],
        [7.1905889, 45.4061142],
        [7.1640357, 45.4243928],
        [7.1201847, 45.4352953],
        [7.1053076, 45.4557603],
        [7.1087907, 45.466428],
        [7.0619575, 45.4729274],
        [7.0533296, 45.4768969],
        [7.0643866, 45.4863434],
        [7.0598944, 45.4937441],
        [7.0267743, 45.4960407],
        [7.008304, 45.5049271],
        [7.0095966, 45.5201942],
        [7.0002114, 45.5305003],
        [7.0000963, 45.5746653],
        [6.9879161, 45.582382],
        [6.9883889, 45.6184126],
        [7.0068515, 45.6392732],
        [6.9683723, 45.6552918],
        [6.9418599, 45.6455706],
        [6.9205403, 45.6518529],
        [6.9060679, 45.663259],
        [6.9135172, 45.6755723],
        [6.9022846, 45.6796347],
        [6.8904574, 45.6765119],
        [6.849207, 45.6907974],
        [6.8371269, 45.7002953],
        [6.8135376, 45.7264716],
        [6.8236126, 45.7395864],
        [6.8088041, 45.7473863],
        [6.8035878, 45.7782329],
        [6.8164204, 45.8092617],
        [6.8090798, 45.8140597],
        [6.8199044, 45.8361567],
        [6.8475526, 45.8431607],
        [6.8732774, 45.826805],
        [6.8813363, 45.8463047],
        [6.8853396, 45.8479459],
        [6.8939653, 45.8430904],
        [6.9457414, 45.8454837],
        [6.9533003, 45.8586931],
        [6.9967069, 45.8686167],
        [7.008308, 45.8987788],
        [7.0464052, 45.9215251],
        [7.0412293, 45.9514851],
        [7.0199559, 45.9595835],
        [7.0145926, 45.9724238],
        [7.0252031, 45.9755875],
        [7.0116643, 45.9986835],
        [6.9900635, 46.0031829],
        [6.9861281, 46.0177655],
        [6.9677057, 46.0293391],
        [6.9419867, 46.0619384],
        [6.9267298, 46.0652627],
        [6.9194493, 46.0556451],
        [6.895106, 46.0431145],
        [6.8736268, 46.049387],
        [6.8982525, 46.0808372],
        [6.8889755, 46.0938291],
        [6.9017046, 46.1221543],
        [6.8526225, 46.1241281],
        [6.8466835, 46.1306727],
        [6.8193321, 46.1290587],
        [6.8005413, 46.1370134],
        [6.7941091, 46.1534884],
        [6.8117555, 46.1789238],
        [6.8107167, 46.1978904],
        [6.8232806, 46.2244278],
        [6.8418847, 46.2453165],
        [6.8578682, 46.2500863],
        [6.8692477, 46.2775683],
        [6.8612253, 46.2905065],
        [6.8480457, 46.2883291],
        [6.8327617, 46.3078605],
        [6.8025386, 46.3198698],
        [6.7918994, 46.332905],
        [6.7798863, 46.3450907],
        [6.775285, 46.35248],
        [6.7786868, 46.3622603],
        [6.7919557, 46.3653443],
        [6.8057425, 46.3747146],
        [6.8084123, 46.3755102],
        [6.8082234, 46.3890358],
        [6.7581827, 46.3982047],
        [6.7402975, 46.4025045],
        [6.7143997, 46.4044084],
        [6.6490464, 46.4015042],
        [6.6281267, 46.4004953],
        [6.6151423, 46.4009853],
        [6.5995593, 46.4015712],
        [6.5743263, 46.3953079],
        [6.5532039, 46.3915897],
        [6.5238264, 46.3989841],
        [6.4947768, 46.3937449],
        [6.4842468, 46.375211],
        [6.4464777, 46.3576648],
        [6.419158, 46.3577503],
        [6.4132261, 46.3480535],
        [6.4091327, 46.3454988],
        [6.3917304, 46.3389139],
        [6.3648214, 46.3443779],
        [6.3556367, 46.3609205],
        [6.3546716, 46.3654586],
        [6.3496127, 46.3674399],
        [6.3208594, 46.3657502],
        [6.3035276, 46.3600518],
        [6.2966463, 46.3548866],
        [6.283278, 46.349948],
        [6.2730251, 46.3340905],
        [6.2527933, 46.3059637],
        [6.2568155, 46.2896104],
        [6.2429507, 46.2774769],
        [6.2733339, 46.2484986],
        [6.2988574, 46.2602205],
        [6.3089573, 46.2562622],
        [6.3125807, 46.2525317],
        [6.312893, 46.239009],
        [6.3014873, 46.2249947],
        [6.2908064, 46.2208643],
        [6.2811583, 46.2130933],
        [6.2338555, 46.2048245],
        [6.2299091, 46.2040593],
        [6.2148418, 46.1928663],
        [6.1973844, 46.1844545],
        [6.1904086, 46.1774867],
        [6.1923604, 46.1684121],
        [6.1815085, 46.1615762],
        [6.1510112, 46.1518004],
        [6.1518005, 46.1445667],
        [6.1411451, 46.1404222],
        [6.1205248, 46.1420164],
        [6.10255, 46.144418],
        [6.1003352, 46.1498956],
        [6.0550186, 46.1504961],
        [6.0504067, 46.1398381],
        [6.0437603, 46.137355],
        [5.9936442, 46.143491],
        [5.9863975, 46.1320168],
        [5.9626523, 46.1255761],
        [5.9590723, 46.1301937],
        [5.9724787, 46.1369687],
        [5.9701924, 46.1415457],
        [5.9763219, 46.1557595],
        [5.9849808, 46.1689906],
        [6.0011076, 46.1774752],
        [5.9965345, 46.1866302],
        [5.9687276, 46.197435],
        [5.9750432, 46.2143454],
        [6.0009934, 46.2144067],
        [6.0243384, 46.2334641],
        [6.0374715, 46.2357377],
        [6.0477094, 46.2336009],
        [6.0551724, 46.2288517],
        [6.0675026, 46.2383549],
        [6.0925423, 46.2438322],
        [6.1050605, 46.2371108],
        [6.1280123, 46.2498562],
        [6.1186473, 46.2645805],
        [6.1096516, 46.2846967],
        [6.1271891, 46.294021],
        [6.126769, 46.306645],
        [6.1315363, 46.3190957],
        [6.1417454, 46.334967],
        [6.1592437, 46.3433861],
        [6.1766526, 46.368921],
        [6.1732654, 46.3762424],
        [6.1576849, 46.376768],
        [6.1076835, 46.4063629],
        [6.0666676, 46.415824],
        [6.066914, 46.4194195],
        [6.0843055, 46.4449681],
        [6.0897547, 46.4483912],
        [6.0805913, 46.4667075],
        [6.098371, 46.4787312],
        [6.1244824, 46.5165955],
        [6.1617813, 46.5459744],
        [6.1417014, 46.5574547],
        [6.1169022, 46.5762968],
        [6.1771681, 46.6157164],
        [6.2003613, 46.6293444],
        [6.215548, 46.6405377],
        [6.2610097, 46.6723134],
        [6.2749132, 46.683544],
        [6.3046896, 46.6969263],
        [6.3397065, 46.7101171],
        [6.3614094, 46.7201637],
        [6.3681431, 46.722629],
        [6.4000823, 46.7467224],
        [6.4443055, 46.7595546],
        [6.4637035, 46.790387],
        [6.4471111, 46.7963905],
        [6.4417322, 46.8118995],
        [6.4652132, 46.8615044],
        [6.4713473, 46.8901108],
        [6.4628643, 46.8994261],
        [6.4516182, 46.9070372],
        [6.439879, 46.9254761],
        [6.4413953, 46.9281241],
        [6.448571, 46.9359743],
        [6.4538862, 46.9366852],
        [6.4750799, 46.9557411],
        [6.4822613, 46.9635901],
        [6.4903438, 46.9660012],
        [6.4933852, 46.9712948],
        [6.5039534, 46.9718126],
        [6.5087851, 46.9662318],
        [6.5854948, 46.9877406],
        [6.6002915, 46.9916973],
        [6.6240635, 46.9926144],
        [6.6418496, 47.0009581],
        [6.6580973, 47.0228722],
        [6.6841434, 47.0354043],
        [6.7026828, 47.0365025],
        [6.7235641, 47.0501234],
        [6.7034873, 47.0626012],
        [6.6974992, 47.0700364],
        [6.7295004, 47.0904421],
        [6.7398741, 47.0882425],
        [6.750615, 47.0905338],
        [6.7522426, 47.1102949],
        [6.8232013, 47.1381837],
        [6.8330186, 47.1450093],
        [6.8596946, 47.1637866],
        [6.8484496, 47.1714367],
        [6.8636955, 47.1798485],
        [6.8965127, 47.2082912],
        [6.9578295, 47.2445958],
        [6.9596917, 47.2508301],
        [6.9509995, 47.2881226],
        [7.0128048, 47.2982506],
        [7.0203682, 47.3240768],
        [7.0483357, 47.3256418],
        [7.0584543, 47.3351416],
        [7.0656128, 47.3411575],
        [7.0477024, 47.3635168],
        [7.0125723, 47.3712518],
        [7.005256, 47.3634383],
        [6.9408908, 47.3552072],
        [6.9091761, 47.3564665],
        [6.8864046, 47.3537622],
        [6.8850624, 47.3691323],
        [6.8979571, 47.3803368],
        [6.9142824, 47.3850984],
        [6.9165313, 47.3958217],
        [6.921272, 47.4046437],
        [6.9412657, 47.4056527],
        [6.9449947, 47.4334373],
        [6.9676458, 47.4343345],
        [6.9766812, 47.4465871],
        [6.9886719, 47.4470069],
        [7.0063513, 47.4517018],
        [7.005736, 47.4598369],
        [6.9970975, 47.4673929],
        [6.9910258, 47.4739438],
        [6.9901822, 47.4947028],
        [7.0293931, 47.5021317],
        [7.0450531, 47.4987937],
        [7.0801026, 47.4892539],
        [7.1018592, 47.4946685],
        [7.1424094, 47.5020045],
        [7.1718176, 47.4890658],
        [7.204425, 47.4967119],
        [7.2084006, 47.4965447],
        [7.2080711, 47.4929533],
        [7.2050932, 47.489474],
        [7.1956575, 47.4880677],
        [7.1822837, 47.4579873],
        [7.1755187, 47.4420478],
        [7.2120781, 47.4351068],
        [7.2374648, 47.4367384],
        [7.2482129, 47.4236639],
        [7.252098, 47.4225972],
        [7.3253704, 47.4392888],
        [7.3374468, 47.4405706],
        [7.3803433, 47.4305969],
        [7.4035985, 47.4376932],
        [7.434678, 47.4570592],
        [7.4486874, 47.4645535],
        [7.4560837, 47.4723397],
        [7.4291437, 47.4825423],
        [7.4383763, 47.4956556],
        [7.4602865, 47.4883794],
        [7.4832531, 47.4783463],
        [7.5086526, 47.4934403],
        [7.5106601, 47.5140844],
        [7.5267307, 47.515168],
        [7.5355575, 47.5237861],
        [7.5323704, 47.532042],
        [7.5012806, 47.5271222],
        [7.5025889, 47.5405851],
        [7.5122177, 47.5437613],
        [7.5499406, 47.5619029],
        [7.5753985, 47.5769808],
        [7.5897207, 47.573629],
        [7.5933563, 47.5969027],
        [7.5949487, 47.5995346],
        [7.5747853, 47.6247861],
        [7.5685014, 47.6286751],
        [7.5675277, 47.6323244],
        [7.5285658, 47.6566085],
        [7.5169224, 47.7012955],
        [7.5369422, 47.7148232],
        [7.5520055, 47.7321774],
        [7.5430415, 47.7497036],
        [7.5339831, 47.7663333],
        [7.5322902, 47.7763228],
        [7.5426624, 47.8001975],
        [7.5463865, 47.8108462],
        [7.5573055, 47.826581],
        [7.5664544, 47.8514095],
        [7.557209, 47.8662446],
        [7.5814847, 47.8948985],
        [7.5824681, 47.918289],
        [7.5834493, 47.9281598],
        [7.6055371, 47.9478959],
        [7.6265735, 47.9703801],
        [7.6107414, 47.9999368],
        [7.5936379, 48.0169311],
        [7.5798205, 48.0265635],
        [7.5725983, 48.0349979],
        [7.5762596, 48.058267],
        [7.5724235, 48.0872782],
        [7.5769772, 48.0924817],
        [7.580909, 48.1049234],
        [7.5770704, 48.1204162],
        [7.6026258, 48.1336902],
        [7.601745, 48.1517536],
        [7.6141833, 48.1683176],
        [7.6305629, 48.1838023],
        [7.63988, 48.1959978],
        [7.6446323, 48.2029931],
        [7.6676524, 48.2172716],
        [7.6824137, 48.2562547],
        [7.6966782, 48.3033691],
        [7.7458629, 48.321846],
        [7.7464657, 48.3407442],
        [7.7364846, 48.3619305],
        [7.7356392, 48.4061271],
        [7.7534316, 48.4341486],
        [7.756685, 48.4394072],
        [7.7666883, 48.4704867],
        [7.7700921, 48.490156],
        [7.8052299, 48.5020521],
        [7.8002842, 48.5842847],
        [7.8336845, 48.6304956],
        [7.8401386, 48.6401085],
        [7.8859206, 48.6614017],
        [7.8947108, 48.6672973],
        [7.9214839, 48.6885665],
        [7.9661865, 48.7243015],
        [7.9644476, 48.7333946],
        [7.9783101, 48.7606718],
        [8.0162767, 48.7588612],
        [8.0180245, 48.7623819],
        [8.0273617, 48.7853647],
        [8.0386074, 48.7884304],
        [8.0603133, 48.7873862],
        [8.0877765, 48.80138],
        [8.1039986, 48.8123088],
        [8.1041367, 48.825819],
        [8.1043374, 48.8276132],
        [8.1208579, 48.8655611],
        [8.1406755, 48.8961366],
        [8.1641948, 48.9229235],
        [8.1856672, 48.9434993],
        [8.2307013, 48.9665132],
        [8.2207328, 48.975117],
        [8.1955181, 48.9700509],
        [8.1934042, 48.9755607],
        [8.1633535, 48.9761339],
        [8.1323428, 48.9803488],
        [8.0908333, 48.9886673],
        [8.0698424, 48.9968866],
        [7.9444274, 49.0524003],
        [7.9323495, 49.054769],
        [7.9170619, 49.0401701],
        [7.9011855, 49.0454155],
        [7.8862822, 49.0470098],
        [7.8696494, 49.0324683],
        [7.8575726, 49.0348286],
        [7.8017005, 49.0635227],
        [7.7841946, 49.0535136],
        [7.733593, 49.0413989],
        [7.73218, 49.0540737],
        [7.6950729, 49.0530427],
        [7.6958753, 49.0476019],
        [7.6791404, 49.0447502],
        [7.6399597, 49.0500991],
        [7.6311621, 49.0712038],
        [7.5979644, 49.081677],
        [7.5592924, 49.078871],
        [7.5208723, 49.1057591],
        [7.5013572, 49.1300156],
        [7.4935218, 49.1339565],
        [7.5033365, 49.1497413],
        [7.4913759, 49.1673661],
        [7.4512796, 49.1645838],
        [7.4459884, 49.1666114],
        [7.4404853, 49.180351],
        [7.3933676, 49.1760478],
        [7.3639474, 49.1700845],
        [7.3629505, 49.1458166],
        [7.3637042, 49.1394815],
        [7.3228779, 49.1429925],
        [7.3072217, 49.1229357],
        [7.2899619, 49.1146484],
        [7.2845843, 49.115771],
        [7.2838196, 49.1221048],
        [7.2485547, 49.1262599],
        [7.2084196, 49.1224985],
        [7.2009104, 49.115603],
        [7.1884298, 49.1287142],
        [7.1677623, 49.127749],
        [7.1600918, 49.1190558],
        [7.1334326, 49.1273305],
        [7.1293007, 49.1418993],
        [7.1070126, 49.1382886],
        [7.1082594, 49.1517419],
        [7.0847673, 49.1499751],
        [7.0859314, 49.1328269],
        [7.0699893, 49.1235563],
        [7.0704514, 49.1136364],
        [7.0524429, 49.1116473],
        [7.0470876, 49.128061],
        [7.0450916, 49.1362406],
        [7.0303236, 49.154824],
        [7.0320631, 49.1889594],
        [7.0197479, 49.1894417],
        [6.9994687, 49.1929342],
        [6.9788662, 49.2081343],
        [6.9666273, 49.2095083],
        [6.9524556, 49.2046542],
        [6.9513278, 49.2073967],
        [6.9409382, 49.2140979],
        [6.9361034, 49.2214827],
        [6.9265996, 49.2227478],
        [6.9006775, 49.2093371],
        [6.8841713, 49.2090648],
        [6.8606347, 49.2225557],
        [6.8391497, 49.2125653],
        [6.8553719, 49.1939555],
        [6.8634524, 49.1765501],
        [6.8466418, 49.1726848],
        [6.8456999, 49.1619209],
        [6.8450715, 49.1547438],
        [6.8337394, 49.1506711],
        [6.8070104, 49.1588712],
        [6.7760946, 49.1663213],
        [6.7525316, 49.1635934],
        [6.7307974, 49.1661932],
        [6.7167415, 49.1784058],
        [6.7146914, 49.1865804],
        [6.7312776, 49.20397],
        [6.7203316, 49.2205687],
        [6.6978882, 49.2150889],
        [6.6836545, 49.2416997],
        [6.6882203, 49.2469342],
        [6.6834214, 49.2552069],
        [6.6628655, 49.2559496],
        [6.6689421, 49.2791251],
        [6.6476832, 49.2879883],
        [6.6331223, 49.2948092],
        [6.5910183, 49.3179006],
        [6.5944306, 49.325877],
        [6.5924318, 49.3349455],
        [6.5787047, 49.3354297],
        [6.5647874, 49.3503162],
        [6.5694252, 49.3564497],
        [6.5897242, 49.3521351],
        [6.5964836, 49.3671899],
        [6.5815239, 49.3695178],
        [6.5827858, 49.3847675],
        [6.5532954, 49.3948014],
        [6.5412961, 49.3997188],
        [6.5365334, 49.4088805],
        [6.5539141, 49.4190685],
        [6.5477036, 49.4273818],
        [6.5343916, 49.4332441],
        [6.4835823, 49.4529957],
        [6.4731538, 49.4605499],
        [6.4377337, 49.4662583],
        [6.4343233, 49.475369],
        [6.4275128, 49.4765],
        [6.4091163, 49.4708266],
        [6.4032543, 49.466527],
        [6.3823256, 49.4636338],
        [6.3798583, 49.467315],
        [6.3702925, 49.468535],
        [6.3710335, 49.4604151],
        [6.3627757, 49.4606907],
        [6.3466128, 49.4657265],
        [6.3329194, 49.467082],
        [6.2970052, 49.4844567],
        [6.2811743, 49.49397],
        [6.2803487, 49.5011907],
        [6.2505263, 49.5084577],
        [6.2339971, 49.5089928],
        [6.2130606, 49.5060696],
        [6.1787561, 49.5089673],
        [6.1534893, 49.5034736],
        [6.1556396, 49.4953115],
        [6.1468417, 49.4883965],
        [6.1290044, 49.4898576],
        [6.1192176, 49.4694818],
        [6.1026298, 49.4691017],
        [6.1013115, 49.4511584],
        [6.0525485, 49.4634634],
        [6.0403672, 49.4476506],
        [6.0173606, 49.4537524],
        [5.9855137, 49.4520234],
        [5.9728572, 49.487475],
        [5.9661636, 49.4903739],
        [5.9390575, 49.4974796],
        [5.8920955, 49.4970758],
        [5.8702394, 49.5004158],
        [5.8397798, 49.5192868],
        [5.8460937, 49.5307923],
        [5.8371198, 49.5409407],
        [5.8203304, 49.5378305],
        [5.8137403, 49.5425158],
        [5.7790974, 49.5614901],
        [5.7596669, 49.5602439],
        [5.7570866, 49.5423364],
        [5.6974942, 49.5395156],
        [5.6732027, 49.5482807],
        [5.6414836, 49.5491531],
        [5.6338925, 49.5385719],
        [5.6180907, 49.5291146],
        [5.6226825, 49.5146052],
        [5.6152152, 49.5058187],
        [5.6055696, 49.5060805],
        [5.5995387, 49.5197295],
        [5.5778827, 49.5266061],
        [5.5545574, 49.5290269],
        [5.5340766, 49.5106937],
        [5.528452, 49.5090441],
        [5.4868856, 49.5065413],
        [5.4820891, 49.4958793],
        [5.4658824, 49.5016948],
        [5.467701, 49.5088391],
        [5.4582173, 49.5117813],
        [5.4530888, 49.5182073],
        [5.4672012, 49.5232342],
        [5.4681346, 49.5384914],
        [5.4452916, 49.54897],
        [5.4439119, 49.549005],
        [5.4546086, 49.5658082],
        [5.4422997, 49.5679234],
        [5.4338915, 49.5888119],
        [5.4341089, 49.5924024],
        [5.4075788, 49.6110551],
        [5.3927087, 49.6168235],
        [5.3629602, 49.6283579],
        [5.3478181, 49.6296347],
        [5.3388422, 49.6181733],
        [5.3235429, 49.6167553],
        [5.3218485, 49.6114039],
        [5.3177027, 49.6115065],
        [5.3048309, 49.6280014],
        [5.33112, 49.651619],
        [5.3178765, 49.6618323],
        [5.3100008, 49.6692148],
        [5.2923893, 49.675937],
        [5.2843516, 49.6806259],
        [5.2792862, 49.6888375],
        [5.2670943, 49.6936274],
        [5.2499306, 49.6841558],
        [5.2350216, 49.6899055],
        [5.2223178, 49.6857148],
        [5.2144762, 49.6939905],
        [5.2004917, 49.6916251],
        [5.1672896, 49.6924055],
        [5.1615664, 49.7141071],
        [5.145997, 49.7081778],
        [5.1241494, 49.7140742],
        [5.1242973, 49.7167661],
        [5.1263204, 49.7284007],
        [5.1186495, 49.7402603],
        [5.1000944, 49.7559591],
        [5.0962773, 49.7623352],
        [5.0698599, 49.7611367],
        [5.0548628, 49.7659662],
        [5.0152024, 49.7767309],
        [5.0005233, 49.7878358],
        [4.9996061, 49.7968395],
        [4.9539496, 49.7996311],
        [4.945079, 49.7890397],
        [4.9296018, 49.7848795],
        [4.8936098, 49.786541],
        [4.8645464, 49.7880493],
        [4.8592688, 49.7935494],
        [4.8758626, 49.8201549],
        [4.8590774, 49.8456594],
        [4.8570128, 49.8600751],
        [4.8901226, 49.9105888],
        [4.8542973, 49.9454688],
        [4.8156278, 49.9516517],
        [4.7977668, 49.956505],
        [4.7974644, 49.9789663],
        [4.8157719, 49.9830858],
        [4.8215732, 50.0162011],
        [4.8464012, 50.0390444],
        [4.8251704, 50.0610342],
        [4.8253483, 50.0646226],
        [4.8393307, 50.0652353],
        [4.8457492, 50.0821673],
        [4.8514164, 50.0838473],
        [4.8462847, 50.092934],
        [4.8535264, 50.098172],
        [4.8712064, 50.088827],
        [4.8808757, 50.0868292],
        [4.8728267, 50.1211243],
        [4.8928147, 50.1296883],
        [4.8986226, 50.1340558],
        [4.8904761, 50.138717],
        [4.8855268, 50.1513926],
        [4.8366617, 50.1524019],
        [4.8301688, 50.1624134],
        [4.8260685, 50.1642915],
        [4.7871856, 50.1408309],
        [4.7689099, 50.1385016],
        [4.7596747, 50.1207248],
        [4.7493497, 50.1092553],
        [4.7196299, 50.1008579],
        [4.7152345, 50.0964532],
        [4.7040366, 50.0957734],
        [4.6859227, 50.0664869],
        [4.6981337, 50.0590673],
        [4.6940924, 50.0322016],
        [4.6931316, 50.0115654],
        [4.6923382, 49.9945156],
        [4.5844004, 49.97949],
        [4.5801081, 49.9768748],
        [4.5701301, 49.9716689],
        [4.5378948, 49.9668662],
        [4.5246378, 49.9500423],
        [4.4530702, 49.9360376],
        [4.4020624, 49.9476908],
        [4.3840928, 49.9506894],
        [4.3548831, 49.9511763],
        [4.3109676, 49.9671625],
        [4.2397062, 49.9602144],
        [4.2353973, 49.9566894],
        [4.2005222, 49.9545341],
        [4.2037338, 49.9661592],
        [4.1720252, 49.9747229],
        [4.1484004, 49.9759742],
        [4.1685634, 49.9945305],
        [4.1401265, 50.0174027],
        [4.1633824, 50.0439959],
        [4.1816613, 50.0482096],
        [4.2309737, 50.0618207],
        [4.2326387, 50.0689788],
        [4.2288895, 50.0807101],
        [4.2048507, 50.1098118],
        [4.2000965, 50.132331],
        [4.1638344, 50.1337764],
        [4.1608473, 50.1284343],
        [4.13309, 50.1333342],
        [4.1332504, 50.1378206],
        [4.1579203, 50.1634923],
        [4.1603549, 50.1921835],
        [4.1582722, 50.2119659],
        [4.2013784, 50.242737],
        [4.2241976, 50.2540585],
        [4.2150387, 50.2712553],
        [4.1843084, 50.2735179],
        [4.1735673, 50.2862474],
        [4.1665983, 50.2872478],
        [4.1549438, 50.2748553],
        [4.1687797, 50.2701603],
        [4.1697543, 50.2584757],
        [4.1403668, 50.2589123],
        [4.1380495, 50.2724103],
        [4.1283127, 50.2743491],
        [4.1222371, 50.3004685],
        [4.108609, 50.311438],
        [4.0832995, 50.3091068],
        [4.0818983, 50.3091273],
        [4.0590967, 50.3390704],
        [4.0423354, 50.3410988],
        [4.0317258, 50.3591971],
        [3.9890971, 50.3427239],
        [3.9709895, 50.3465556],
        [3.9257012, 50.3336877],
        [3.9213824, 50.3301544],
        [3.8890652, 50.3278732],
        [3.8879388, 50.3368625],
        [3.8614957, 50.3434771],
        [3.8617137, 50.3506555],
        [3.8309745, 50.3546222],
        [3.8293586, 50.3474624],
        [3.8195184, 50.3466837],
        [3.8183536, 50.3547748],
        [3.7662904, 50.3491089],
        [3.7424048, 50.3475904],
        [3.7377745, 50.3323855],
        [3.7302444, 50.3136226],
        [3.7260403, 50.3136708],
        [3.7205097, 50.3164264],
        [3.712104, 50.316521],
        [3.7174617, 50.3074853],
        [3.7145608, 50.3039284],
        [3.704805, 50.3058315],
        [3.6912052, 50.3212405],
        [3.6829166, 50.325819],
        [3.6775972, 50.3366466],
        [3.6630069, 50.3682173],
        [3.6674505, 50.3771432],
        [3.6746084, 50.3824501],
        [3.6766118, 50.4048641],
        [3.6704021, 50.4354422],
        [3.6639947, 50.4588432],
        [3.6458209, 50.4626275],
        [3.6170876, 50.4934369],
        [3.6115076, 50.4952897],
        [3.5874443, 50.4892547],
        [3.5792325, 50.4983109],
        [3.5609047, 50.4966985],
        [3.5058291, 50.4873653],
        [3.5047348, 50.5008338],
        [3.5204189, 50.5096569],
        [3.5235483, 50.5230859],
        [3.4716316, 50.5298541],
        [3.4570978, 50.5093518],
        [3.4429508, 50.5058896],
        [3.4090008, 50.4972182],
        [3.3821872, 50.4929623],
        [3.3655314, 50.5038692],
        [3.3360671, 50.5077005],
        [3.3332704, 50.5086196],
        [3.3278209, 50.5176359],
        [3.2886154, 50.5278136],
        [3.282137, 50.5574714],
        [3.2783497, 50.5808253],
        [3.2773296, 50.6014665],
        [3.2731686, 50.6050866],
        [3.2594381, 50.6249264],
        [3.2553905, 50.634824],
        [3.2514545, 50.6510004],
        [3.2475472, 50.6689693],
        [3.267456, 50.6768943],
        [3.2564126, 50.6904316],
        [3.2649342, 50.6930589],
        [3.2539513, 50.7101834],
        [3.2242747, 50.7095023],
        [3.1948618, 50.724061],
        [3.2020816, 50.7329812],
        [3.1965678, 50.7410909],
        [3.1839545, 50.7474558],
        [3.1756851, 50.7600692],
        [3.1645244, 50.7691134],
        [3.1549036, 50.7862172],
        [3.1322434, 50.7845707],
        [3.1280279, 50.7863912],
        [3.1182095, 50.791835],
        [3.1068654, 50.7901116],
        [3.1067406, 50.782042],
        [3.0910717, 50.774962],
        [3.0642546, 50.7787097],
        [3.0386954, 50.7716817],
        [3.0175061, 50.7735953],
        [2.9889745, 50.7549131],
        [2.9535556, 50.7488169],
        [2.9478563, 50.7452566],
        [2.9393542, 50.7435047],
        [2.9377776, 50.7300602],
        [2.9247545, 50.7041107],
        [2.9106137, 50.7023837],
        [2.9006557, 50.6961513],
        [2.8936847, 50.7042549],
        [2.8739237, 50.7052393],
        [2.8571526, 50.722352],
        [2.8175343, 50.7162343],
        [2.7685496, 50.7693297],
        [2.7601015, 50.7738429],
        [2.74602, 50.7810653],
        [2.7277646, 50.7981627],
        [2.7321019, 50.8098076],
        [2.6882783, 50.8171134],
        [2.6684671, 50.818065],
        [2.6401175, 50.8118603],
        [2.6092, 50.8522862],
        [2.6191824, 50.8639212],
        [2.6121381, 50.8711102],
        [2.6080669, 50.9042957],
        [2.6010489, 50.9177596],
        [2.6053329, 50.9231309],
        [2.6352518, 50.9445819],
        [2.6127898, 50.9885656],
        [2.5787593, 51.0011878],
        [2.5662013, 51.0505184],
        [2.5620086, 51.066662],
        [2.5549732, 51.0846041],
        [2.5478694, 51.0873047],
        [2.4980034, 51.0712432],
        [2.4809184, 51.0667817],
        [2.4709502, 51.0641035],
        [2.4353679, 51.0542771],
        [2.3955343, 51.0471288],
        [2.3329626, 51.0543151],
        [2.3087857, 51.0480356],
        [2.2675547, 51.0417454],
        [2.2419742, 51.0345562],
        [2.1723507, 51.0219328],
        [2.1112972, 51.0074935],
        [2.1013722, 51.0029925],
        [1.9778393, 50.9919392],
        [1.9408854, 50.9945161],
        [1.9125753, 50.9827673],
        [1.8304305, 50.9600464],
        [1.7581918, 50.9462814],
        [1.7172369, 50.9299449],
        [1.7144567, 50.9254467],
        [1.6948056, 50.9092074],
        [1.6455468, 50.8820424],
        [1.6371311, 50.8757176],
        [1.6159393, 50.871114],
        [1.5833744, 50.8691257],
        [1.5820407, 50.8637384],
        [1.5910373, 50.8306117],
        [1.5982776, 50.8198933],
        [1.6056321, 50.8011039],
        [1.5979662, 50.7454538],
        [1.5996331, 50.7284222],
        [1.5897568, 50.7274665],
        [1.5884106, 50.7229729],
        [1.5647273, 50.7013007],
        [1.5663047, 50.6905472],
        [1.5766111, 50.6628041],
        [1.5812233, 50.6377163],
        [1.581766, 50.6018365],
        [1.5849362, 50.5785316],
        [1.5837304, 50.5650677],
        [1.6122875, 50.5383248],
        [1.6123265, 50.5356342],
        [1.5898325, 50.5337047],
        [1.5821029, 50.4861068],
        [1.5795364, 50.4699413],
        [1.575796, 50.4385144],
        [1.5608979, 50.4025289],
        [1.5666508, 50.3935921],
        [1.5751394, 50.3891579],
        [1.5879455, 50.3775719],
        [1.6019755, 50.3776562],
        [1.6076927, 50.370512],
        [1.6063545, 50.3660173],
        [1.5615356, 50.3612548],
        [1.5536506, 50.3271044],
        [1.5498103, 50.3037456],
        [1.5431886, 50.2794727],
        [1.5546965, 50.2598023],
        [1.5925575, 50.2555496],
        [1.6295184, 50.2153824],
        [1.6490716, 50.2172891],
        [1.6701125, 50.2129166],
        [1.6815086, 50.1968231],
        [1.6858902, 50.1824846],
        [1.6775732, 50.1770558],
        [1.6523575, 50.1814053],
        [1.6242402, 50.1929126],
        [1.6005543, 50.1873872],
        [1.5794527, 50.1962339],
        [1.5653221, 50.2060176],
        [1.566597, 50.214104],
        [1.5414515, 50.2121485],
        [1.4943694, 50.1840092],
        [1.4727766, 50.1389781],
        [1.4593106, 50.1101576],
        [1.4469391, 50.0992963],
        [1.4317356, 50.0911053],
        [1.4276147, 50.0874844],
        [1.4206872, 50.0847394],
        [1.3902361, 50.0719376],
        [1.383381, 50.0656005],
        [1.3750499, 50.0637404],
        [1.3433162, 50.0464296],
        [1.2867646, 50.0172267],
        [1.2813053, 50.0117926],
        [1.2702184, 50.0090025],
        [1.2633704, 50.0035561],
        [1.2386145, 49.9889711],
        [1.2221024, 49.9798423],
        [1.1986822, 49.9688511],
        [1.1738381, 49.9596383],
        [1.1655107, 49.9586605],
        [1.1531345, 49.9522547],
        [1.1323745, 49.947563],
        [1.1227639, 49.9420799],
        [1.0619945, 49.924398],
        [1.0260053, 49.9177296],
        [0.9759104, 49.9189762],
        [0.9577401, 49.9223628],
        [0.9412275, 49.915889],
        [0.9358159, 49.9104388],
        [0.9068037, 49.9038157],
        [0.8472809, 49.8950204],
        [0.8404396, 49.8913442],
        [0.8142814, 49.8829371],
        [0.8061098, 49.8774455],
        [0.7673541, 49.8724607],
        [0.7506885, 49.8722446],
        [0.7172395, 49.875396],
        [0.6785552, 49.8685893],
        [0.6591719, 49.8665256],
        [0.6481237, 49.8645767],
        [0.6095157, 49.8559525],
        [0.5750231, 49.8491699],
        [0.5695642, 49.8463956],
        [0.5299484, 49.8278503],
        [0.5216876, 49.8259308],
        [0.5163304, 49.8204615],
        [0.4862654, 49.8074329],
        [0.4342984, 49.7868695],
        [0.4014007, 49.776469],
        [0.3974116, 49.7719144],
        [0.3753054, 49.7697615],
        [0.3605126, 49.7578448],
        [0.3495688, 49.7540729],
        [0.3442376, 49.7485946],
        [0.3292462, 49.7420601],
        [0.3057356, 49.7407701],
        [0.2960755, 49.7397104],
        [0.2782506, 49.7349169],
        [0.2756256, 49.7312789],
        [0.2633456, 49.7265784],
        [0.2305199, 49.71613],
        [0.2125973, 49.7140204],
        [0.1897087, 49.6983452],
        [0.1855944, 49.6973728],
        [0.1815938, 49.6937087],
        [0.1720593, 49.6899455],
        [0.166021, 49.669174],
        [0.1497342, 49.6293498],
        [0.1339267, 49.6110939],
        [0.118244, 49.5901426],
        [0.0844783, 49.5409966],
        [0.0730154, 49.5192168],
        [0.0734526, 49.5093396],
        [0.0974808, 49.4963113],
        [0.0937011, 49.4881532],
        [0.1009842, 49.479302],
        [0.1304236, 49.468163],
        [0.2020653, 49.4694525],
        [0.2439487, 49.4567081],
        [0.2605494, 49.4551991],
        [0.2785285, 49.4537097],
        [0.3130339, 49.4524978],
        [0.3915422, 49.4537912],
        [0.3917481, 49.4484021],
        [0.376702, 49.4454629],
        [0.3479554, 49.440499],
        [0.3177312, 49.4381994],
        [0.3039252, 49.4388661],
        [0.2903369, 49.4341423],
        [0.2630173, 49.4282827],
        [0.2216823, 49.4284632],
        [0.1932231, 49.4171774],
        [0.1563299, 49.4102225],
        [0.1453599, 49.4091263],
        [0.1359587, 49.4035628],
        [0.1129967, 49.3932546],
        [0.1104796, 49.3878173],
        [0.0917327, 49.3757856],
        [0.0825014, 49.3666261],
        [0.0583527, 49.3526894],
        [0.0382156, 49.3415218],
        [0.0193827, 49.332172],
        [-0.0130565, 49.319859],
        [-0.0361191, 49.3131133],
        [-0.0497697, 49.3110463],
        [-0.0619606, 49.3072081],
        [-0.0877138, 49.2995009],
        [-0.1408727, 49.2903264],
        [-0.1682389, 49.2879603],
        [-0.2161024, 49.2833569],
        [-0.2742966, 49.2928919],
        [-0.2825785, 49.2936111],
        [-0.3077499, 49.302048],
        [-0.3372358, 49.3139804],
        [-0.3555125, 49.3216619],
        [-0.3722772, 49.3266777],
        [-0.375215, 49.3302084],
        [-0.3946862, 49.3342615],
        [-0.4319706, 49.3370042],
        [-0.4595436, 49.3381642],
        [-0.4707337, 49.3414989],
        [-0.4984084, 49.3444451],
        [-0.5467994, 49.3486885],
        [-0.5644593, 49.3446668],
        [-0.5904117, 49.3413396],
        [-0.6067955, 49.3391433],
        [-0.6233832, 49.3405334],
        [-0.6234875, 49.3423293],
        [-0.6387549, 49.3446493],
        [-0.6650166, 49.3466925],
        [-0.7145842, 49.3472426],
        [-0.7422247, 49.3492359],
        [-0.7865181, 49.3534865],
        [-0.8240037, 49.3588016],
        [-0.857373, 49.3642133],
        [-0.8742597, 49.3700568],
        [-0.9095835, 49.3843929],
        [-0.9209816, 49.390379],
        [-0.9598831, 49.3956132],
        [-0.9819431, 49.3959046],
        [-1.0162593, 49.3940555],
        [-1.0324633, 49.3891065],
        [-1.0560722, 49.3920398],
        [-1.0805794, 49.3877499],
        [-1.0843465, 49.3822469],
        [-1.1118227, 49.3607808],
        [-1.102796, 49.3493504],
        [-1.1101947, 49.3365493],
        [-1.1129421, 49.3364701],
        [-1.1307346, 49.3350578],
        [-1.1406513, 49.339268],
        [-1.1469365, 49.3507758],
        [-1.1349377, 49.3565193],
        [-1.1449813, 49.3625234],
        [-1.1694069, 49.3573166],
        [-1.1792074, 49.3597293],
        [-1.1836398, 49.3640951],
        [-1.1768914, 49.3660914],
        [-1.1657852, 49.405081],
        [-1.17077, 49.4175246],
        [-1.1823281, 49.42528],
        [-1.1882652, 49.4314012],
        [-1.205829, 49.4461706],
        [-1.2145844, 49.4531085],
        [-1.2262197, 49.4617549],
        [-1.2323519, 49.4705662],
        [-1.2426168, 49.4792529],
        [-1.2662925, 49.5019264],
        [-1.2736887, 49.5088979],
        [-1.2841584, 49.5202741],
        [-1.2962678, 49.535195],
        [-1.3027386, 49.5484871],
        [-1.3050144, 49.5610056],
        [-1.2980798, 49.580097],
        [-1.2847904, 49.5876894],
        [-1.2596998, 49.5848417],
        [-1.2630897, 49.5937309],
        [-1.2519935, 49.6129418],
        [-1.2255116, 49.6101304],
        [-1.2268893, 49.6298683],
        [-1.2376877, 49.6457315],
        [-1.2354276, 49.6529901],
        [-1.2485577, 49.6624907],
        [-1.2577356, 49.6748036],
        [-1.2634544, 49.6773323],
        [-1.261894, 49.694459],
        [-1.2964639, 49.6934263],
        [-1.3217407, 49.6980585],
        [-1.3413616, 49.7010598],
        [-1.3625616, 49.7067083],
        [-1.4122206, 49.7033823],
        [-1.4244707, 49.7003049],
        [-1.4460619, 49.6924401],
        [-1.4671367, 49.696275],
        [-1.4817792, 49.6697386],
        [-1.4994074, 49.6646859],
        [-1.5265014, 49.6566303],
        [-1.5430115, 49.6552032],
        [-1.5653928, 49.6580795],
        [-1.6019315, 49.647004],
        [-1.6156065, 49.6447591],
        [-1.6263213, 49.657897],
        [-1.6444217, 49.6590999],
        [-1.6720519, 49.6581876],
        [-1.6766924, 49.664329],
        [-1.6802324, 49.6741026],
        [-1.6993672, 49.670768],
        [-1.7112052, 49.6802646],
        [-1.7651782, 49.6793463],
        [-1.806203, 49.6896395],
        [-1.8230115, 49.6917612],
        [-1.8358312, 49.7129015],
        [-1.8484988, 49.7151631],
        [-1.8557084, 49.7185107],
        [-1.8714896, 49.70807],
        [-1.8924545, 49.7100383],
        [-1.909083, 49.7265427],
        [-1.9257587, 49.7268574],
        [-1.9395131, 49.7254723],
        [-1.9449195, 49.7072951],
        [-1.931349, 49.694283],
        [-1.9409753, 49.6768554],
        [-1.8931736, 49.6686431],
        [-1.8856719, 49.6617108],
        [-1.8687995, 49.6587006],
        [-1.8586104, 49.6527591],
        [-1.8509678, 49.6440295],
        [-1.8390254, 49.6165631],
        [-1.8377041, 49.6004196],
        [-1.8363836, 49.5842759],
        [-1.8368097, 49.5725693],
        [-1.8562423, 49.5566048],
        [-1.866757, 49.5499432],
        [-1.8818896, 49.5323245],
        [-1.8725122, 49.5191602],
        [-1.8541636, 49.5144025],
        [-1.8470549, 49.5119512],
        [-1.8387766, 49.4951473],
        [-1.8425264, 49.4734302],
        [-1.8299186, 49.4711673],
        [-1.8204139, 49.4391132],
        [-1.8142501, 49.414139],
        [-1.8159102, 49.4005881],
        [-1.8044746, 49.3784926],
        [-1.8041125, 49.3740082],
        [-1.7751922, 49.3741006],
        [-1.7522808, 49.3631881],
        [-1.7448424, 49.3562438],
        [-1.7388497, 49.3501506],
        [-1.7192947, 49.3292223],
        [-1.7053562, 49.3269937],
        [-1.7034884, 49.3207604],
        [-1.6957812, 49.3102241],
        [-1.6866327, 49.298836],
        [-1.6745365, 49.2848479],
        [-1.6625169, 49.2717547],
        [-1.657498, 49.2602282],
        [-1.6448602, 49.2390567],
        [-1.6236036, 49.212774],
        [-1.6058654, 49.2142581],
        [-1.6034677, 49.200843],
        [-1.5971667, 49.1902549],
        [-1.5911402, 49.1472698],
        [-1.5902516, 49.1356027],
        [-1.5981773, 49.1137519],
        [-1.6020745, 49.1109244],
        [-1.6027506, 49.0839115],
        [-1.59817, 49.0597686],
        [-1.5957097, 49.0454547],
        [-1.5787884, 49.0028235],
        [-1.5718325, 49.0012525],
        [-1.5679449, 49.0040782],
        [-1.5587344, 49.0088784],
        [-1.5517105, 49.0064085],
        [-1.5537623, 48.9973436],
        [-1.5578655, 48.9792144],
        [-1.5583493, 48.9675005],
        [-1.5599261, 48.9521536],
        [-1.5608817, 48.9467242],
        [-1.5516944, 48.9335281],
        [-1.5595297, 48.928773],
        [-1.5649195, 48.9096988],
        [-1.5677185, 48.8925125],
        [-1.569763, 48.8834464],
        [-1.5721537, 48.8608713],
        [-1.5833777, 48.8470039],
        [-1.6087374, 48.8398661],
        [-1.6027529, 48.8328652],
        [-1.5877985, 48.8333596],
        [-1.5703315, 48.8186369],
        [-1.5668109, 48.7899565],
        [-1.5679808, 48.7512206],
        [-1.5491908, 48.7365375],
        [-1.524361, 48.7319492],
        [-1.516444, 48.7169065],
        [-1.4993327, 48.6877653],
        [-1.4976468, 48.6833191],
        [-1.4784021, 48.6803398],
        [-1.4534096, 48.6730432],
        [-1.4477245, 48.6696249],
        [-1.44952, 48.6569677],
        [-1.4344182, 48.6547488],
        [-1.4270664, 48.6657817],
        [-1.4042839, 48.6701027],
        [-1.4074443, 48.6574053],
        [-1.364602, 48.6470522],
        [-1.3555167, 48.6338356],
        [-1.3595164, 48.6328122],
        [-1.3762197, 48.6385886],
        [-1.4170557, 48.6400024],
        [-1.4522135, 48.6379831],
        [-1.4503363, 48.6308427],
        [-1.4709146, 48.633783],
        [-1.4800027, 48.6280919],
        [-1.5004516, 48.6292298],
        [-1.5051757, 48.6380774],
        [-1.5187885, 48.6385355],
        [-1.5168355, 48.6304991],
        [-1.545478, 48.6322626],
        [-1.5714143, 48.63411],
        [-1.5999925, 48.6349644],
        [-1.6258515, 48.617901],
        [-1.6728251, 48.6109194],
        [-1.7608168, 48.6079072],
        [-1.7878867, 48.6069656],
        [-1.8416098, 48.6167846],
        [-1.8532367, 48.6262773],
        [-1.866944, 48.6446952],
        [-1.8625408, 48.657453],
        [-1.8318223, 48.6810415],
        [-1.8381944, 48.7096219],
        [-1.8423367, 48.7103759],
        [-1.8886335, 48.6943344],
        [-1.9173984, 48.6969061],
        [-1.9524256, 48.6929437],
        [-1.9476923, 48.6850133],
        [-1.9595944, 48.6809823],
        [-1.9627512, 48.6862682],
        [-1.9828573, 48.6828365],
        [-1.9828722, 48.6666321],
        [-2.0407475, 48.643801],
        [-2.0542157, 48.6424034],
        [-2.0821954, 48.6359611],
        [-2.0961189, 48.6399411],
        [-2.1112456, 48.6420761],
        [-2.1227408, 48.63354],
        [-2.1483853, 48.631671],
        [-2.1176504, 48.605821],
        [-2.1228322, 48.6029244],
        [-2.1385667, 48.6122347],
        [-2.149779, 48.6163122],
        [-2.1663657, 48.603978],
        [-2.1580493, 48.5862848],
        [-2.1641148, 48.5779514],
        [-2.1820085, 48.58087],
        [-2.1827569, 48.6051527],
        [-2.1911103, 48.6075355],
        [-2.1932708, 48.6011498],
        [-2.2047655, 48.5772978],
        [-2.2128795, 48.5769861],
        [-2.2204094, 48.6010076],
        [-2.2504728, 48.6340627],
        [-2.2427449, 48.6388651],
        [-2.2431395, 48.6433522],
        [-2.2515017, 48.6457297],
        [-2.2724522, 48.6368127],
        [-2.2878193, 48.626308],
        [-2.3139298, 48.6144804],
        [-2.3308118, 48.6210192],
        [-2.2818496, 48.6661608],
        [-2.3082294, 48.6723334],
        [-2.3095117, 48.6866913],
        [-2.3232255, 48.6879529],
        [-2.3248873, 48.6761811],
        [-2.4022015, 48.6442976],
        [-2.4029016, 48.6370662],
        [-2.4135677, 48.6348381],
        [-2.4230856, 48.6497646],
        [-2.4639546, 48.6508165],
        [-2.4824126, 48.644665],
        [-2.4648411, 48.6309691],
        [-2.4951574, 48.6063199],
        [-2.5487637, 48.598714],
        [-2.5709953, 48.575277],
        [-2.6154971, 48.5436973],
        [-2.6204756, 48.538985],
        [-2.6301727, 48.5268675],
        [-2.6517808, 48.525957],
        [-2.6609185, 48.5363797],
        [-2.6781334, 48.5320485],
        [-2.6711794, 48.5161278],
        [-2.683214, 48.5003043],
        [-2.6994478, 48.5140262],
        [-2.7094217, 48.5190051],
        [-2.7174787, 48.5321735],
        [-2.7115443, 48.5549469],
        [-2.7673517, 48.5705685],
        [-2.7783979, 48.5863061],
        [-2.8116457, 48.5929718],
        [-2.8178526, 48.600809],
        [-2.8105373, 48.6092352],
        [-2.8141301, 48.6180877],
        [-2.8236524, 48.6455993],
        [-2.8203913, 48.6538494],
        [-2.8492532, 48.6706046],
        [-2.8525906, 48.6767648],
        [-2.8634238, 48.67629],
        [-2.8603483, 48.6863342],
        [-2.8742479, 48.7028405],
        [-2.8888811, 48.6994938],
        [-2.933882, 48.7272287],
        [-2.9231451, 48.7556333],
        [-2.9409698, 48.770156],
        [-2.9480265, 48.7725437],
        [-2.9569744, 48.7667397],
        [-2.9724464, 48.7714551],
        [-2.9832996, 48.7709692],
        [-3.0272071, 48.7870106],
        [-3.0112303, 48.8039478],
        [-3.0164142, 48.8145242],
        [-3.0702973, 48.8210943],
        [-3.0771333, 48.8342946],
        [-3.0753071, 48.8560002],
        [-3.0699647, 48.8832689],
        [-3.0782147, 48.8837951],
        [-3.0866965, 48.8734988],
        [-3.1039883, 48.8691052],
        [-3.1682879, 48.8445245],
        [-3.1706248, 48.8408122],
        [-3.1966373, 48.8287912],
        [-3.2002162, 48.8367334],
        [-3.2063054, 48.8553711],
        [-3.2171606, 48.867479],
        [-3.270347, 48.8541688],
        [-3.2986774, 48.8510276],
        [-3.3319313, 48.8305229],
        [-3.3635305, 48.8200012],
        [-3.3962046, 48.819329],
        [-3.4208359, 48.8199399],
        [-3.4361666, 48.8228007],
        [-3.476185, 48.8388751],
        [-3.4842284, 48.8375794],
        [-3.5234385, 48.8221329],
        [-3.5353494, 48.8188414],
        [-3.5412544, 48.79872],
        [-3.5542096, 48.7926697],
        [-3.5714336, 48.7882094],
        [-3.5795992, 48.7760854],
        [-3.5715942, 48.7656664],
        [-3.5477657, 48.7479226],
        [-3.5528105, 48.7323486],
        [-3.5804466, 48.7237618],
        [-3.5825946, 48.6948104],
        [-3.5669872, 48.6892784],
        [-3.5708727, 48.6755645],
        [-3.5826434, 48.6713714],
        [-3.6070033, 48.6701508],
        [-3.6124998, 48.6824954],
        [-3.6394656, 48.6802356],
        [-3.6521629, 48.6841023],
        [-3.6466336, 48.6951987],
        [-3.6577736, 48.6973402],
        [-3.6735021, 48.6920347],
        [-3.6979723, 48.6916931],
        [-3.7117203, 48.704515],
        [-3.7446328, 48.7064368],
        [-3.7755624, 48.7030421],
        [-3.8026629, 48.7133627],
        [-3.816522, 48.7153477],
        [-3.8183785, 48.7080394],
        [-3.8375476, 48.7088449],
        [-3.8551123, 48.6619437],
        [-3.8504506, 48.6342345],
        [-3.859914, 48.6337387],
        [-3.8796973, 48.6399158],
        [-3.8911573, 48.6447225],
        [-3.9001762, 48.6631848],
        [-3.8897861, 48.667338],
        [-3.8879396, 48.6746489],
        [-3.9194876, 48.6765926],
        [-3.9258776, 48.6618277],
        [-3.9378332, 48.659391],
        [-3.9487602, 48.6597128],
        [-3.9704295, 48.7036495],
        [-3.9650272, 48.72648],
        [-3.9883755, 48.7279423],
        [-3.9912347, 48.7178705],
        [-4.0006039, 48.7164674],
        [-4.0003448, 48.7254995],
        [-4.0086882, 48.7268568],
        [-4.0091667, 48.7196159],
        [-4.0519686, 48.7019849],
        [-4.0560574, 48.6909431],
        [-4.0682346, 48.6902847],
        [-4.0904397, 48.6935925],
        [-4.1553858, 48.6900486],
        [-4.1939456, 48.6825166],
        [-4.2230135, 48.6538496],
        [-4.2417132, 48.6510072],
        [-4.2717934, 48.652037],
        [-4.2975725, 48.6406706],
        [-4.3016253, 48.6404441],
        [-4.3091856, 48.646334],
        [-4.2938995, 48.6652342],
        [-4.3051753, 48.66821],
        [-4.3101479, 48.6751485],
        [-4.3254837, 48.6778944],
        [-4.3471209, 48.676674],
        [-4.39495, 48.656823],
        [-4.4300934, 48.6548184],
        [-4.4272273, 48.6432521],
        [-4.4479118, 48.6348499],
        [-4.4913196, 48.623328],
        [-4.5255091, 48.6348838],
        [-4.5369116, 48.6387344],
        [-4.5824465, 48.6126171],
        [-4.6056754, 48.6031333],
        [-4.5984838, 48.5900183],
        [-4.6091947, 48.5785593],
        [-4.6439181, 48.5738044],
        [-4.6602283, 48.5737418],
        [-4.6994755, 48.5723132],
        [-4.7024479, 48.5540835],
        [-4.7234053, 48.5582489],
        [-4.7595853, 48.5344157],
        [-4.7589804, 48.5200096],
        [-4.7757696, 48.5036544],
        [-4.7661029, 48.4825715],
        [-4.7590082, 48.4703606],
        [-4.7757837, 48.4440738],
        [-4.7924186, 48.4168887],
        [-4.773225, 48.4054105],
        [-4.7602795, 48.3800128],
        [-4.768471, 48.3704921],
        [-4.7821528, 48.3714686],
        [-4.783863, 48.3641438],
        [-4.7806896, 48.3607247],
        [-4.7699425, 48.3514444],
        [-4.7681168, 48.338013],
        [-4.7697075, 48.3297924],
        [-4.7074528, 48.3299288],
        [-4.6934035, 48.3361861],
        [-4.6950894, 48.3487228],
        [-4.6740775, 48.3535876],
        [-4.6222174, 48.3404207],
        [-4.5924276, 48.3403761],
        [-4.550102, 48.3582057],
        [-4.4864134, 48.3682341],
        [-4.4301679, 48.3940441],
        [-4.4167184, 48.3948158],
        [-4.4022273, 48.3875249],
        [-4.4230017, 48.3700899],
        [-4.4542905, 48.329483],
        [-4.4417366, 48.326597],
        [-4.4001377, 48.3398176],
        [-4.3957607, 48.3373614],
        [-4.4041267, 48.3287596],
        [-4.4051223, 48.3259965],
        [-4.3671665, 48.3254602],
        [-4.3638594, 48.3418915],
        [-4.3383289, 48.3433432],
        [-4.3328123, 48.3319264],
        [-4.3309843, 48.3175912],
        [-4.3110403, 48.3096974],
        [-4.3034173, 48.3029098],
        [-4.3274444, 48.2898185],
        [-4.3516079, 48.2884455],
        [-4.3641114, 48.2805142],
        [-4.3816737, 48.2804141],
        [-4.4114294, 48.2805118],
        [-4.4145051, 48.2938728],
        [-4.4591509, 48.2940046],
        [-4.4987151, 48.2862943],
        [-4.5077067, 48.2929919],
        [-4.495687, 48.3045205],
        [-4.4962726, 48.3090004],
        [-4.5046798, 48.3112184],
        [-4.5332064, 48.2915028],
        [-4.5458748, 48.2952751],
        [-4.5302778, 48.3413143],
        [-4.5542217, 48.3381082],
        [-4.5765064, 48.3223576],
        [-4.5658888, 48.2931975],
        [-4.5648249, 48.2851372],
        [-4.5833749, 48.2822394],
        [-4.5989668, 48.2876376],
        [-4.627892, 48.2814126],
        [-4.6188889, 48.2747259],
        [-4.6217533, 48.2555992],
        [-4.5834924, 48.2524465],
        [-4.5533539, 48.2596336],
        [-4.5457513, 48.242931],
        [-4.5703983, 48.235164],
        [-4.5627528, 48.2283937],
        [-4.5584207, 48.2160107],
        [-4.5549753, 48.1692762],
        [-4.537214, 48.1676121],
        [-4.4968295, 48.2304458],
        [-4.4418618, 48.2336348],
        [-4.4381374, 48.2257279],
        [-4.4038154, 48.2213875],
        [-4.3721415, 48.2060561],
        [-4.3300235, 48.2039456],
        [-4.316395, 48.2029156],
        [-4.2952503, 48.1851629],
        [-4.2919661, 48.159179],
        [-4.272541, 48.1548619],
        [-4.2702983, 48.1477701],
        [-4.284407, 48.1099745],
        [-4.2968572, 48.0912197],
        [-4.3769395, 48.1065076],
        [-4.4523693, 48.0958393],
        [-4.5807656, 48.0783875],
        [-4.6189342, 48.0716119],
        [-4.7161204, 48.0630815],
        [-4.7071584, 48.0464668],
        [-4.7106849, 48.0426435],
        [-4.7388507, 48.0418445],
        [-4.7420142, 48.0353334],
        [-4.6508976, 48.0182454],
        [-4.6434838, 48.0232034],
        [-4.6344918, 48.0264467],
        [-4.6227446, 48.0190234],
        [-4.6018888, 48.0139437],
        [-4.5691835, 48.0005355],
        [-4.5490021, 48.0107548],
        [-4.5367529, 48.0096704],
        [-4.4598518, 47.9870902],
        [-4.4105284, 47.9484298],
        [-4.3995875, 47.9364264],
        [-4.3740321, 47.9045015],
        [-4.3652058, 47.8878612],
        [-4.3539137, 47.8623339],
        [-4.3494346, 47.8481496],
        [-4.3471649, 47.8302275],
        [-4.3766316, 47.8195045],
        [-4.3722264, 47.7953877],
        [-4.2987448, 47.7968941],
        [-4.2791145, 47.7898886],
        [-4.2312385, 47.7926019],
        [-4.2061915, 47.7958165],
        [-4.1759311, 47.8002226],
        [-4.1616095, 47.8362181],
        [-4.1492783, 47.8558563],
        [-4.1085423, 47.8626291],
        [-4.0882376, 47.8610443],
        [-4.0738053, 47.8636442],
        [-4.0436652, 47.8472512],
        [-4.0322204, 47.852389],
        [-3.9786286, 47.8526001],
        [-3.9833512, 47.8920434],
        [-3.9698693, 47.9026969],
        [-3.9500311, 47.8938442],
        [-3.9257238, 47.8698914],
        [-3.9097357, 47.8707491],
        [-3.9046787, 47.8619984],
        [-3.9135789, 47.8579119],
        [-3.9031946, 47.8494459],
        [-3.8506605, 47.7900002],
        [-3.8067578, 47.7923263],
        [-3.7689824, 47.7898041],
        [-3.7356256, 47.8023726],
        [-3.7195503, 47.8023075],
        [-3.6735966, 47.774924],
        [-3.6684789, 47.7769922],
        [-3.6607007, 47.7791985],
        [-3.6129239, 47.7708265],
        [-3.5332419, 47.7640509],
        [-3.4982494, 47.7378535],
        [-3.4455822, 47.6962936],
        [-3.4317476, 47.7041965],
        [-3.4127572, 47.7015303],
        [-3.3654997, 47.7092696],
        [-3.3556164, 47.7043431],
        [-3.3428084, 47.7094791],
        [-3.3401522, 47.709608],
        [-3.2829966, 47.699762],
        [-3.2791976, 47.6891255],
        [-3.2924826, 47.6884817],
        [-3.3469694, 47.6984543],
        [-3.3523613, 47.6864678],
        [-3.3400196, 47.683463],
        [-3.339366, 47.6898076],
        [-3.2932402, 47.6830346],
        [-3.2700873, 47.6787437],
        [-3.2128166, 47.641821],
        [-3.1559041, 47.6075603],
        [-3.138903, 47.584921],
        [-3.1363113, 47.5597982],
        [-3.140164, 47.5325662],
        [-3.1568304, 47.5263666],
        [-3.1433657, 47.4990532],
        [-3.1288662, 47.4744914],
        [-3.0832275, 47.4703267],
        [-3.0951896, 47.4832907],
        [-3.1197164, 47.501974],
        [-3.1270412, 47.521465],
        [-3.1268497, 47.5584414],
        [-3.1233582, 47.5892611],
        [-3.1196549, 47.5921405],
        [-3.1013087, 47.5821823],
        [-3.0970973, 47.567053],
        [-3.0452986, 47.5685665],
        [-3.0104639, 47.5665727],
        [-2.9806657, 47.5616328],
        [-2.9358456, 47.5528618],
        [-2.9337286, 47.5583673],
        [-2.9648111, 47.602927],
        [-2.9566122, 47.6276422],
        [-2.9435171, 47.6300403],
        [-2.940147, 47.6229825],
        [-2.9141195, 47.5890064],
        [-2.9137637, 47.5854163],
        [-2.9005884, 47.586913],
        [-2.8859054, 47.6001952],
        [-2.8573202, 47.6213093],
        [-2.7817417, 47.6255694],
        [-2.7695332, 47.6234022],
        [-2.7088149, 47.6017229],
        [-2.7015212, 47.6371888],
        [-2.6903875, 47.6322638],
        [-2.6753275, 47.6139888],
        [-2.6859151, 47.5991111],
        [-2.6878904, 47.5918144],
        [-2.7033496, 47.5722168],
        [-2.7223453, 47.5479545],
        [-2.7258098, 47.5423959],
        [-2.8552527, 47.5456826],
        [-2.8867972, 47.5550829],
        [-2.9098655, 47.5594498],
        [-2.9124227, 47.5449109],
        [-2.9021713, 47.5354577],
        [-2.867189, 47.5316265],
        [-2.8468865, 47.5145079],
        [-2.8506958, 47.4990126],
        [-2.8031291, 47.4885135],
        [-2.7949235, 47.486173],
        [-2.727521, 47.5044652],
        [-2.6799707, 47.4939159],
        [-2.6568306, 47.5165468],
        [-2.6272597, 47.5133115],
        [-2.6292384, 47.5060165],
        [-2.6115994, 47.5022652],
        [-2.6008446, 47.5153406],
        [-2.5525637, 47.5110813],
        [-2.5455193, 47.5212913],
        [-2.5031926, 47.523968],
        [-2.4970767, 47.5152117],
        [-2.4632985, 47.5094066],
        [-2.4387236, 47.5023115],
        [-2.4253947, 47.5019603],
        [-2.4221024, 47.4948861],
        [-2.4680589, 47.4884831],
        [-2.4780614, 47.4961782],
        [-2.5041455, 47.4905844],
        [-2.5007617, 47.4826153],
        [-2.4810502, 47.4410811],
        [-2.4551483, 47.4484653],
        [-2.4462393, 47.4380196],
        [-2.4520475, 47.4287685],
        [-2.4353665, 47.4204455],
        [-2.4360477, 47.4132082],
        [-2.4708404, 47.4162728],
        [-2.4997934, 47.3988431],
        [-2.5545871, 47.3740063],
        [-2.5243654, 47.3626645],
        [-2.5035044, 47.3374044],
        [-2.5123704, 47.3036848],
        [-2.5437194, 47.2987582],
        [-2.5417426, 47.2916308],
        [-2.5023368, 47.280673],
        [-2.4502693, 47.2612172],
        [-2.4169776, 47.2589889],
        [-2.422054, 47.2713969],
        [-2.4094994, 47.2791252],
        [-2.3547747, 47.2741539],
        [-2.2974089, 47.2386261],
        [-2.2932191, 47.2360905],
        [-2.1969955, 47.2714536],
        [-2.1853982, 47.2908308],
        [-2.1779354, 47.2965303],
        [-2.1668445, 47.2906553],
        [-2.1527795, 47.2966104],
        [-2.1003487, 47.3031433],
        [-2.0685852, 47.3034587],
        [-2.0360939, 47.3110014],
        [-2.0066026, 47.3067089],
        [-1.9878995, 47.3047077],
        [-1.9390421, 47.3065282],
        [-1.8908314, 47.2830813],
        [-1.8604524, 47.2670736],
        [-1.8377243, 47.2471799],
        [-1.7877385, 47.2165503],
        [-1.7928041, 47.2136657],
        [-1.8390286, 47.2300157],
        [-1.8606205, 47.2355392],
        [-1.86333, 47.2363403],
        [-1.9492189, 47.2683139],
        [-2.0126966, 47.2839565],
        [-2.0291206, 47.2905435],
        [-2.0409276, 47.2891953],
        [-2.1269908, 47.2732831],
        [-2.1663466, 47.2690504],
        [-2.1778243, 47.2325589],
        [-2.1577807, 47.2144211],
        [-2.1576654, 47.1973048],
        [-2.164169, 47.1646127],
        [-2.2266814, 47.1540415],
        [-2.2258417, 47.1441627],
        [-2.2434222, 47.1335517],
        [-2.1737817, 47.1218874],
        [-2.0502959, 47.0969304],
        [-2.0301987, 47.0769715],
        [-2.0177824, 47.0702363],
        [-1.9763371, 47.0303537],
        [-2.0223147, 47.0123986],
        [-2.035808, 47.0001726],
        [-2.0421382, 46.948573],
        [-2.0702563, 46.9384846],
        [-2.0970536, 46.9284403],
        [-2.1201775, 46.905918],
        [-2.110557, 46.9008853],
        [-2.1203719, 46.8923942],
        [-2.1514399, 46.8866745],
        [-2.1425724, 46.8590872],
        [-2.1392874, 46.8195667],
        [-2.1252376, 46.8084019],
        [-2.0542828, 46.7751049],
        [-1.9834297, 46.7255456],
        [-1.9811195, 46.7130202],
        [-1.9640145, 46.6956447],
        [-1.9561114, 46.6950408],
        [-1.9429839, 46.6946333],
        [-1.9245956, 46.6773017],
        [-1.9105542, 46.6652106],
        [-1.9085435, 46.6562758],
        [-1.8956059, 46.6414397],
        [-1.8793239, 46.6339347],
        [-1.8731996, 46.6224489],
        [-1.8622093, 46.6156468],
        [-1.845854, 46.5901197],
        [-1.8339645, 46.5545184],
        [-1.8227172, 46.5441181],
        [-1.8182532, 46.5199559],
        [-1.8155059, 46.5011347],
        [-1.803111, 46.4925778],
        [-1.7812013, 46.4960765],
        [-1.7593002, 46.4824532],
        [-1.7105988, 46.4589727],
        [-1.6967981, 46.4486517],
        [-1.6460817, 46.4324247],
        [-1.6506198, 46.423257],
        [-1.627876, 46.4150449],
        [-1.5662973, 46.4099726],
        [-1.5503893, 46.4060135],
        [-1.536421, 46.4109962],
        [-1.4992839, 46.4014482],
        [-1.4751227, 46.3725364],
        [-1.4681664, 46.3475477],
        [-1.4389313, 46.3386184],
        [-1.3556491, 46.3377583],
        [-1.3355784, 46.329403],
        [-1.3244754, 46.3189545],
        [-1.3083404, 46.2915517],
        [-1.2907087, 46.2804101],
        [-1.2751551, 46.2809066],
        [-1.2700303, 46.2819708],
        [-1.2710419, 46.2972499],
        [-1.2594917, 46.2994191],
        [-1.2527057, 46.2753172],
        [-1.210293, 46.2622422],
        [-1.1949167, 46.2654255],
        [-1.1980347, 46.2734342],
        [-1.1947288, 46.2825434],
        [-1.1835276, 46.2900972],
        [-1.1907071, 46.3006813],
        [-1.1641701, 46.31231],
        [-1.1523807, 46.3108734],
        [-1.1262704, 46.3089735],
        [-1.1064509, 46.2627473],
        [-1.1276818, 46.249491],
        [-1.1338162, 46.2438999],
        [-1.1715204, 46.2247246],
        [-1.1966595, 46.2122346],
        [-1.2027254, 46.2057395],
        [-1.2003826, 46.1896021],
        [-1.2143236, 46.1846626],
        [-1.2245023, 46.161826],
        [-1.2040514, 46.1462576],
        [-1.1733656, 46.1526193],
        [-1.1726133, 46.1409352],
        [-1.1551729, 46.1315679],
        [-1.1460968, 46.1111347],
        [-1.1379424, 46.1050821],
        [-1.125687, 46.0955522],
        [-1.1105249, 46.1014199],
        [-1.1010848, 46.0954042],
        [-1.0870927, 46.0580053],
        [-1.0539776, 46.0454971],
        [-1.0550557, 46.0211496],
        [-1.0463128, 46.005203],
        [-1.0510273, 45.9978566],
        [-1.0751945, 45.9917254],
        [-1.0958245, 45.9910984],
        [-1.082034, 45.9771088],
        [-1.0707127, 45.9612417],
        [-1.0639889, 45.956942],
        [-1.0638221, 45.9542461],
        [-1.0658422, 45.9451787],
        [-1.0864549, 45.9445544],
        [-1.0897033, 45.9345489],
        [-1.0701008, 45.9306411],
        [-1.0695982, 45.9225524],
        [-1.0745829, 45.8989875],
        [-1.0887392, 45.8778436],
        [-1.0925439, 45.876828],
        [-1.1069683, 45.8601774],
        [-1.1155217, 45.8527094],
        [-1.1678513, 45.8447859],
        [-1.1672774, 45.8357983],
        [-1.1419948, 45.8230735],
        [-1.1272294, 45.8136249],
        [-1.1344315, 45.8052981],
        [-1.1224124, 45.7984637],
        [-1.1255304, 45.7866608],
        [-1.1279873, 45.7847845],
        [-1.1512233, 45.7858662],
        [-1.1416283, 45.7969699],
        [-1.1510219, 45.8029822],
        [-1.1767783, 45.8030801],
        [-1.2070393, 45.7931215],
        [-1.2532892, 45.7916526],
        [-1.2465718, 45.7873638],
        [-1.2491763, 45.7089285],
        [-1.23524, 45.6922612],
        [-1.2197975, 45.6720392],
        [-1.2069795, 45.6724445],
        [-1.2012047, 45.6825336],
        [-1.1819725, 45.6831404],
        [-1.1437083, 45.6672242],
        [-1.1317196, 45.6603918],
        [-1.0778302, 45.6404347],
        [-1.0539364, 45.6276541],
        [-1.0380133, 45.6191313],
        [-1.0216355, 45.6241265],
        [-1.0068916, 45.6137609],
        [-1.0112501, 45.6010244],
        [-0.9918803, 45.5989008],
        [-0.986848, 45.5792405],
        [-0.9803401, 45.5776319],
        [-0.9745734, 45.5669975],
        [-0.9494563, 45.5542319],
        [-0.9290927, 45.55663],
        [-0.9185915, 45.5524335],
        [-0.9091607, 45.5446053],
        [-0.9086317, 45.5356157],
        [-0.8929176, 45.5297694],
        [-0.8600583, 45.5154071],
        [-0.8056428, 45.4818363],
        [-0.7841825, 45.4644324],
        [-0.7771885, 45.4538229],
        [-0.7648863, 45.4397595],
        [-0.7537681, 45.4238633],
        [-0.7424057, 45.40347],
        [-0.7286313, 45.3624352],
        [-0.7138485, 45.3259294],
        [-0.7000648, 45.2839943],
        [-0.6899716, 45.239256],
        [-0.6845884, 45.2105944],
        [-0.6652298, 45.1823119],
        [-0.6608844, 45.1725271],
        [-0.666022, 45.149882],
        [-0.6669046, 45.1426571],
        [-0.6499732, 45.1116071],
        [-0.6360774, 45.0894753],
        [-0.6344253, 45.0823182],
        [-0.6303314, 45.0770275],
        [-0.6128385, 45.0585901],
        [-0.6009974, 45.0508027],
        [-0.58935, 45.0466097],
        [-0.5739471, 45.0434156],
        [-0.5407951, 45.0406813],
        [-0.5120287, 45.024322],
        [-0.4921949, 45.0086289],
        [-0.4920124, 45.0050331],
        [-0.4969888, 45.0031057],
        [-0.517951, 45.0160687],
        [-0.5851695, 45.0395204],
        [-0.6004764, 45.0409162],
        [-0.5963425, 45.0347237],
        [-0.5304114, 44.986943],
        [-0.5260116, 44.9753556],
        [-0.5296254, 44.9716618],
        [-0.53886, 44.9786225],
        [-0.5416722, 44.9839507],
        [-0.5586493, 44.9934098],
        [-0.5823461, 45.0098895],
        [-0.6080669, 45.01641],
        [-0.6238478, 45.0267914],
        [-0.6369055, 45.0336417],
        [-0.6449936, 45.0424267],
        [-0.6528425, 45.0467163],
        [-0.6662474, 45.0598569],
        [-0.6799024, 45.0774889],
        [-0.6868814, 45.0890019],
        [-0.6955714, 45.108569],
        [-0.7113557, 45.141445],
        [-0.7310203, 45.1751125],
        [-0.7410127, 45.1946422],
        [-0.7454507, 45.2287288],
        [-0.7431074, 45.2323953],
        [-0.7623542, 45.2804748],
        [-0.7793488, 45.3106115],
        [-0.7933567, 45.3327265],
        [-0.8082945, 45.3485108],
        [-0.82987, 45.3686071],
        [-0.8404338, 45.3746105],
        [-0.8629428, 45.3883712],
        [-0.8999738, 45.4098105],
        [-0.9338418, 45.4421377],
        [-0.979498, 45.4569978],
        [-1.0036263, 45.4751868],
        [-1.0155593, 45.4820337],
        [-1.0236074, 45.488095],
        [-1.0486008, 45.4990464],
        [-1.0699929, 45.5137029],
        [-1.0652623, 45.5408632],
        [-1.0396817, 45.5416392],
        [-1.0399015, 45.5452344],
        [-1.0618615, 45.5688805],
        [-1.0908477, 45.560793],
        [-1.1154633, 45.5240154],
        [-1.1301849, 45.513653],
        [-1.1573685, 45.4776847],
        [-1.1526836, 45.4643228],
        [-1.1478316, 45.448266],
        [-1.15671, 45.4065644],
        [-1.1606226, 45.3875309],
        [-1.1642287, 45.28296],
        [-1.1657755, 45.2468925],
        [-1.1812091, 45.128443],
        [-1.1933751, 45.0596219],
        [-1.2099716, 44.9213266],
        [-1.2282597, 44.8108911],
        [-1.2545959, 44.6695809],
        [-1.2602947, 44.6207766],
        [-1.2411975, 44.6177993],
        [-1.2369107, 44.6494495],
        [-1.2219683, 44.7120551],
        [-1.1556957, 44.7627934],
        [-1.120644, 44.747693],
        [-1.0748144, 44.7212129],
        [-1.0317664, 44.6982309],
        [-1.0341231, 44.695459],
        [-1.0482521, 44.6995271],
        [-1.0608498, 44.699139],
        [-1.0176607, 44.6734575],
        [-1.0328416, 44.6531874],
        [-1.0403965, 44.6529564],
        [-1.0916741, 44.6459691],
        [-1.1120865, 44.6498316],
        [-1.1212286, 44.654946],
        [-1.1353536, 44.6590018],
        [-1.1510736, 44.6684091],
        [-1.1785464, 44.6639331],
        [-1.1960574, 44.6615718],
        [-1.1997327, 44.6398458],
        [-1.2018645, 44.6136696],
        [-1.2440448, 44.5636884],
        [-1.2726005, 44.5573511],
        [-1.2506403, 44.4698456],
        [-1.2749507, 44.3394149],
        [-1.2818646, 44.3103811],
        [-1.2895045, 44.27322],
        [-1.3164519, 44.1283006],
        [-1.3264205, 44.089261],
        [-1.3507063, 44.002035],
        [-1.3843341, 43.887486],
        [-1.3985273, 43.8383992],
        [-1.4110447, 43.8019694],
        [-1.4162937, 43.7873869],
        [-1.4309691, 43.7463804],
        [-1.4407204, 43.6875474],
        [-1.4439415, 43.6613366],
        [-1.4642631, 43.6129307],
        [-1.4775906, 43.5899649],
        [-1.4912055, 43.5714856],
        [-1.5195247, 43.5326837],
        [-1.5287867, 43.5233553],
        [-1.5455205, 43.4966595],
        [-1.565379, 43.4797445],
        [-1.5756116, 43.4667768],
        [-1.5916315, 43.4481977],
        [-1.6027749, 43.4306947],
        [-1.6149041, 43.4275513],
        [-1.6183506, 43.4238245],
        [-1.6580435, 43.408863],
        [-1.6536637, 43.3991269],
        [-1.6643014, 43.3924344],
        [-1.6832627, 43.3989261],
        [-1.7328293, 43.3844661],
        [-1.7393652, 43.3896178],
        [-1.7469396, 43.3920302],
        [-1.7560791, 43.3817853],
        [-1.7820924, 43.3967695],
        [-1.7859576, 43.3853304],
        [-1.7696866, 43.3538003],
        [-1.7317668, 43.3465301],
        [-1.7261699, 43.3160095],
        [-1.7002037, 43.3034199],
        [-1.6747666, 43.30721],
        [-1.6384635, 43.2922304],
        [-1.6194645, 43.2680197],
        [-1.5794583, 43.2562898],
        [-1.5494678, 43.2897496],
        [-1.4015187, 43.2648496],
        [-1.3795446, 43.2374798],
        [-1.4104891, 43.1303],
        [-1.4295327, 43.1106797],
        [-1.464505, 43.0906896],
        [-1.4638101, 43.0674399],
        [-1.4236045, 43.0392298],
        [-1.3513367, 43.0276404],
        [-1.3393176, 43.0912298],
        [-1.3259484, 43.1039403],
        [-1.2886868, 43.1088895],
        [-1.2784076, 43.0573297],
        [-1.2497416, 43.0448998],
        [-1.2188137, 43.0519402],
        [-1.1528604, 43.0303202],
        [-1.1348556, 43.0130196],
        [-1.1045515, 43.0189997],
        [-1.0556378, 42.9945597],
        [-1.0131724, 42.9886799],
        [-0.9924278, 42.9663397],
        [-0.9380965, 42.9497103],
        [-0.9087393, 42.9580597],
        [-0.8702698, 42.9487095],
        [-0.7590676, 42.9654096],
        [-0.7354637, 42.9408004],
        [-0.724717, 42.9006497],
        [-0.6615056, 42.8803404],
        [-0.6433115, 42.8591002],
        [-0.6006466, 42.8296998],
        [-0.5580833, 42.7878996],
        [-0.5357964, 42.7900498],
        [-0.4945514, 42.8246197],
        [-0.4115916, 42.80461],
        [-0.3178311, 42.8488695],
        [-0.2000722, 42.7896998],
        [-0.152332, 42.7998305],
        [-0.1184499, 42.7479299],
        [-0.0752944, 42.7355299],
        [-0.0393355, 42.6975898],
        [-0.0046003, 42.6925396],
        [0.1866171, 42.7419297],
        [0.2218436, 42.7212902],
        [0.240918, 42.7257605],
        [0.2587262, 42.7228096],
        [0.2666912, 42.6953601],
        [0.2978554, 42.6845296],
        [0.3416174, 42.7237303],
        [0.4102237, 42.6937399],
        [0.4767619, 42.7099198],
        [0.6083424, 42.7061199],
        [0.6868484, 42.6973303],
        [0.6820495, 42.7411405],
        [0.6604143, 42.7527501],
        [0.6603142, 42.7897097],
        [0.6804624, 42.8044002],
        [0.6696729, 42.8406999],
        [0.6950556, 42.8585504],
        [0.7355377, 42.8407601],
        [0.8422029, 42.8325104],
        [0.8972929, 42.7960004],
        [0.9555083, 42.79983],
        [0.9930953, 42.7849299],
        [1.0868828, 42.7824996],
        [1.1141305, 42.7626604],
        [1.1344967, 42.7221302],
        [1.1651355, 42.7120605],
        [1.2388356, 42.7291799],
        [1.2797343, 42.7213999],
        [1.3370307, 42.7261703],
        [1.3527026, 42.7067204],
        [1.3792576, 42.6950499],
        [1.4291366, 42.60352],
        [1.4717044, 42.6054196],
        [1.4903435, 42.6224898],
        [1.4965425, 42.6555897],
        [1.5305713, 42.6536496],
        [1.5745444, 42.66066],
        [1.609092, 42.6398703],
        [1.7284181, 42.6060102],
        [1.7218615, 42.5800903],
        [1.7119003, 42.5113802],
        [1.7542345, 42.4912601],
        [1.8176128, 42.4926597],
        [1.9074723, 42.4553604],
        [1.9143074, 42.4330102],
        [1.9433123, 42.4232001],
        [1.969686, 42.3924802],
        [1.9938652, 42.3807],
        [2.0437674, 42.3803601],
        [2.1258562, 42.4219398],
        [2.2342365, 42.4274601],
        [2.2697865, 42.44125],
        [2.3400283, 42.4129602],
        [2.4032721, 42.39659],
        [2.4409589, 42.39312],
        [2.472501, 42.3727199],
        [2.5398325, 42.3771696],
        [2.6117311, 42.3606801],
        [2.6407395, 42.3700897],
        [2.6768112, 42.4182904],
        [2.8080955, 42.4255896],
        [2.859053, 42.4607396],
        [2.9247881, 42.4587002],
        [2.9495894, 42.4771699],
        [3.0244581, 42.4727903],
        [3.0704567, 42.4377],
        [3.0969581, 42.4432202],
        [3.110439, 42.4331195],
        [3.1398501, 42.4438497],
        [3.1824177, 42.4244803],
    ],
};
